import { render, staticRenderFns } from "./circles.vue?vue&type=template&id=e863e6a4&scoped=true&"
import script from "./circles.vue?vue&type=script&lang=js&"
export * from "./circles.vue?vue&type=script&lang=js&"
import style0 from "./circles.vue?vue&type=style&index=0&id=e863e6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e863e6a4",
  null
  
)

component.options.__file = "circles.vue"
export default component.exports